import React from 'react';
import { Box } from '@mui/material';

import Text from 'components/text';
import { FONT } from '../constants';

const StatCard: React.FC<{
  label: string;
  value: React.ReactNode;
}> = ({ label, value }) => (
  <Box flex={1} minWidth={120} border="1px solid #e2e8f0" borderRadius="8px" padding="18px 20px">
    <Text fontSize={30} fontWeight={700} lineHeight={1}>
      {value}
    </Text>
    <Text fontSize={FONT.base} fontWeight={500} color="#64748b" marginTop="8px">
      {label}
    </Text>
  </Box>
);

export default StatCard;
